import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZendeskHelpButtonComponent } from './zendesk-help-button.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [ ZendeskHelpButtonComponent ],
    declarations: [ ZendeskHelpButtonComponent ],
    entryComponents: [ ZendeskHelpButtonComponent ]
})
export class ZendeskHelpButtonModule {}
